import * as StackTrace from 'stacktrace-js';
import axios from 'axios';

enum Level {
  Info = 'Info',
  Error = 'Error',
}

const log = async (level: Level, data) => {
  await axios.post(`Home/Log${level}`, data);
};

export const logInfo = async info => log(Level.Info, { info });

export const logError = async (error: any, react?: any) => {
  await StackTrace.get()
    .then((frames: Array<any>) => {
      const maxWidth = frames.reduce((prev, { functionName }) => {
        const fnLen = (functionName && functionName.length) || 0;
        return prev > fnLen ? prev : fnLen;
      }, 0);

      return frames
        .map(
          frame =>
            `${(frame.functionName as string).padEnd(maxWidth)} @ ${
              frame.fileName
            }:${frame.lineNumber},${frame.columnNumber}`
        )
        .slice(1)
        .join('\n');
    })
    .then(async trace => {
      await log(Level.Error, {
        error,
        trace,
        react,
      });
    });
};
